import { createElement, createContext, useContext, useState, ReactNode } from 'react';
import { ListContextType, ListContextStateType } from './types';

const ListContext = createContext<ListContextType>({});

/**
 * @internal
 */
export const useListContext = () => {
  return useContext(ListContext);
};

/**
 * @internal
 */
export const ListContextProvider = (props: { children?: ReactNode }) => {
  const [listContext, setListContext] = useState<ListContextStateType>({
    tableHasVerticalScrollbar: false,
  });

  const contextValue: ListContextType = {
    setListContext,
    ...listContext,
  };
  return <ListContext.Provider value={contextValue}>{props.children}</ListContext.Provider>;
};
